module.exports = "//d274d294w9cx2v.cloudfront.net/8f4d0790cac6ca77cc9e102ecff779d4e6ffc83d/images/cashRegistryDefaultSmall.webp";